<div class="line-chart-container" [ngStyle]="{ 'height': height ? height + 'px' : '400px' }">
  <canvas
    [id]="id"
    #linechartcanvas
    [attr.width]="width"
    [attr.height]="height"
  ></canvas>
  <div
    class="chart-overlay"
    [ngStyle]="isLoading ? { display: 'block' } : { display: 'none' }"
  ></div>
</div>
